import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import TimerComponent from "../../../components/TimerComponent";

function ExamHeader({
  subjectName,
  setIsTimeUp,
  showSubmitModal,
  handleCloseSubmitModal,
  handleFinalSubmit,
  handleFinalSubmitCheck,
  isTimeUp,
  stats,
  submitError,
  countdownTime,
  finalSubmitChecked,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: { xs: "5px 10px", sm: "6px 16px" },
        borderBottom: "1px solid #e0e0e0",
        background: "linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%)",
        minHeight: { xs: 40, sm: 44 },
      }}
    >
      <Typography
        fontWeight="bold"
        sx={{ fontSize: { xs: "0.85rem", sm: "0.95rem" }, color: "#1565c0" }}
      >
        {subjectName}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <AccessTimeOutlinedIcon sx={{ fontSize: { xs: 16, sm: 18 }, color: "#555" }} />
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, color: "#00695c", fontWeight: 600 }}>
          <TimerComponent
            setIsTimeUp={setIsTimeUp}
            showSubmitModal={showSubmitModal}
            handleCloseSubmitModal={handleCloseSubmitModal}
            handleFinalSubmit={handleFinalSubmit}
            isFormatTime={true}
            isTimeUp={isTimeUp}
            stats={stats}
            submitError={submitError}
            countdownTime={countdownTime}
            finalSubmitChecked={finalSubmitChecked}
            handleFinalSubmitCheck={handleFinalSubmitCheck}
          />
        </Typography>
      </Box>
    </Box>
  );
}

export default ExamHeader;
